module.exports = __webpack_public_path__ + "img/trash.1ef0680d.svg";